import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { AppTheme } from '../../../styles/AppTheme';
import { AppConfig } from '../../../AppConfig';
import { CustomBaseEnityStyles } from '../../../styles/CustomStyles';
import { CircularProgress } from '@material-ui/core';
import { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const queryString = require('query-string');

export class CampaignPgm extends Component {

  constructor(props) {
    super(props)
    this.pageKey = 'CampaignPgm'
    this.orderId = queryString.parse(this.props.location.search).order_id
    // eslint-disable-next-line camelcase
    this.sessionId = queryString.parse(this.props.location.search).session_id
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    };
  }

  componentDidMount() {
    this.fetchItems();
  }

  async fetchItems() {
    const jsonBody = {}
    if (this.orderId && !this.sessionId) {
      jsonBody.orderId = this.orderId
      jsonBody.action = 'GENERATE_PAYMENT_LINK'
      try {
        const response = await ApiHelper.callAwait({
          method: 'POST',
          endPoint: ApiHelper.makeUrlPath(['pgfes']),
          authWithKey: true,
          jsonBody
        })
        // const stripePromise = loadStripe(response.pubKey || 'pk_test_up2LcQj8XUuT2cFbcw5lIzMZ');
        const stripePromise = loadStripe(response.pubKey);
        const stripe = await stripePromise;
        await stripe.redirectToCheckout({ sessionId: response.sessionId });
      } catch (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
      }
    } else if (this.orderId && this.sessionId) {
      jsonBody.orderId = this.orderId
      jsonBody.sessionId = this.sessionId
      jsonBody.action = 'RECONCILE_PAYMENT'
      try {
        const response = await ApiHelper.callAwait({
          method: 'POST',
          endPoint: ApiHelper.makeUrlPath(['pgfes']),
          authWithKey: true,
          jsonBody
        })
        this.setState({
          fetchState: ApiHelper.State.READY,
          errMsg: Helper.getString('paymentSuccess')
        })
      } catch (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
      }
    } else {
      this.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('paymentFailed')
      })
      return
    }
  }

  paymentLoadingView() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.progressContainer)}>
          <p className={css(Styles.title)}>Loading</p>
          <CircularProgress size={window.innerWidth < 768 ? 34 : 44} className={css(Styles.progress)} />
        </div>
        <img className={css(Styles.img)} src={require('../../../assets/images/dolphin-login.png')} />
      </div>
    )
  }

  paymentErrorView() {
    return (
      <div className={css(Styles.container)}>
        <img className={css(Styles.imgFailure)} src={require('../../../assets/images/1.png')} />
        <span className={css(Styles.orderId)}><strong>Order ID:</strong> {this.orderId}</span>
        <span className={css(Styles.errMsg)}>{this.state.errMsg}</span>
      </div>
    )
  }

  paymentSuccessView() {
    return (
      <div className={css(Styles.container)}>
        <img className={css(Styles.imgFailure)} src={require('../../../assets/images/3.png')} />
        <span className={css(Styles.orderId)}><strong>Order ID:</strong> {this.orderId}</span>
        <span className={css(Styles.errMsg)}>{Helper.getString('paymentSuccess')}</span>
      </div>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return this.paymentLoadingView()
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return this.paymentErrorView()
    } else if (this.state.fetchState === ApiHelper.State.READY) {
      return this.paymentSuccessView()
    } else {
      return ''
    }
  }
}

const Styles = (AppConfig.CUSTOM_STYLE) ? CustomBaseEnityStyles : StyleSheet.create({
  title: {
    fontSize: 26,
    '@media (max-width: 767px)': {
      fontSize: 20,
    }
  },
  container: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 15
  },
  img: {
    height: 450,
    '@media (max-width: 767px)': {
      height: 300,
    }
  },
  imgFailure: {
    height: 250,
  },
  imgSuccess: {
    height: 250,
  },
  progress: {
    color: AppTheme.primaryColor
  },
  progressContainer: {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
  },
  link: {
    textDecoration: 'none'
  },
  errMsg: {
    color: '#000000',
    marginBottom: 10,
    fontWeight: 'bold'
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/CampaignPgm.js